import React, { useEffect, useState } from 'react'
import { translateImage } from '../../../images/images'
import { playVoiceOver } from '../../../utils/handleVoiceAndLang';
import { hybridPosvSteps, isNpsSteps, photoVerificationSteps, QCSteps } from '../../../utils/stepperStep';
import HeadStepper from '../../HeadStepper/HeadStepper';
import './ConsentLanguage.css'
import LanguageTranslater from '../../HOC/LanguageTranslater';

function ConsentLanguage({ handleLanguageSelection, translate }) {

    const LANGUAGES = [
        {
            label: "English",
            code: "english"
        },
        {
            label: "বাংলা",
            code: "bengali"
        },
        {
            label: "हिंदी",
            code: "hindi"
        },
        {
            label: "मराठी",
            code: "marathi"
        },
        {
            label: "தமிழ்",
            code: "tamil"
        },
        {
            label: "ಕನ್ನಡ",
            code: "kannada"
        },
        {
            label: "తెలుగు",
            code: "telugu"
        },
        {
            label: "ਪੰਜਾਬੀ",
            code: "punjabi"
        },
        {
            label: "ગુજરાતી",
            code: "gujarati"
        },
        {
            label: "മലയാളം",
            code: "malayalam"
        },
        {
            label: "অসমীয়া",
            code: "assamese"
        },
        {
            label: "ଓଡିଆ",
            code: "oriya"
        },
        {
            label: "اردو",
            code: "urdu"
        },
        {
            label: "भोजपुरी",
            code: "bhojpuri"
        },

    ]



    const [selectedConsentLang, setSelectedConsentLang] = useState("")
    const [showContinueBtn, setShowContinueBtn] = useState(true)
    const [isNps, setIsNps] = useState(localStorage.getItem('isNps'))
    const [isVideoPosv, setIsVideoPosv] = useState(localStorage.getItem('isVideoPosv'))
    const [chanelName, setChanelNamev] = useState(localStorage.getItem('channelName')?.toLocaleLowerCase())
    const [languages, setLanguages] = useState(LANGUAGES)
    const [journeyBy, setJourneyBy] = useState(localStorage.getItem('journeyBy'))
    const [twoStep, setTwoStep] = useState(localStorage.getItem('twoStep'))


    const changeLanguage = (selectedConsentLang) => {
        const ln = selectedConsentLang;
        handleLanguageSelection(ln)
        setShowContinueBtn(false)
        // console.log(selectedConsentLang);
        // console.log(ln);
    };
    const getSteps = () => {
        if (isNps == 'Y' || journeyBy == 'P') {
            return isNpsSteps
        } else if (isVideoPosv == 'Y') {
            return hybridPosvSteps
        } else if (twoStep == 'Y') {
            return QCSteps
        }
        else {
            return photoVerificationSteps
        }
    }

    return (
        <>
            <HeadStepper activeState={2} allSteps={getSteps()} customClass="consent-language-stepper" />
            <div className='consent-language-screen'>
                <div className={`consent-language-contaner axis-consent-language-contaner`}>
                    <div className="consent-translate-image-container">
                        <img className="consent-translate-image" src={translateImage} alt="" />
                        <div className="consent-test-display-container">
                            <span className='consent-test-display'>
                                {translate("select_preferred_language_Video")}
                            </span>
                        </div>
                    </div>



                    <div className="consent-language-select-container">
                        <div className={`consent-languages axis-languages`}>

                            {languages.map((item, index) => (
                                <div key={index} className='consent-lang' >
                                    < div className={index > 6 ? 'consent-lang-detail text-right' : 'consent-lang-detail'} >
                                        <p className={selectedConsentLang == item.code ? "active-lang" : ""}
                                            onClick={() => setSelectedConsentLang(item.code)}
                                        >{item.label}</p>
                                    </div>
                                    {/* <div className="consent-line-hr"></div> */}
                                </div>
                            ))}

                        </div>
                    </div>
                    {
                        showContinueBtn && <div className="consent-select-language-btn">
                            <button disabled={selectedConsentLang ? false : true} style={{ visibility: selectedConsentLang ? 'visible' : 'hidden' }} className='consent-cntnu-btn' type="submit" onClick={() => changeLanguage(selectedConsentLang)}>continue
                            </button>
                        </div>
                    }


                </div >
            </div >
        </>
    )
}
export default LanguageTranslater(ConsentLanguage)
